import React from "react";
import { Modal, Button } from "react-bootstrap";
import lodashGet from "lodash.get";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => {
  return {
    tempoConfigBox: {
      width: "fit-content",
      marginRight: 25,
      marginTop: 10,
    },
    tempoConfigFlexbox: {
      display: "inline-flex",
    },
    noUpdateMessage: {
      margin: "10 0",
    },
  };
});

const ProjectConfig = (props) => {
  const { project, useCaseType, configurationParams } = props;
  const classes = useStyles();

  const hasTempoConfigParams =
    lodashGet(
      project,
      "configurationParameters.iosConfig.tempo.tempoUpdateInterval"
    ) ||
    lodashGet(
      project,
      "configurationParameters.androidConfig.tempo.tempoUpdateInterval"
    );

  return (
    <div className="edit-project-container">
      <h4>{project && project.name}</h4>
      <div className="use-case-type-section">
        <h5>Template</h5>
        <select value={useCaseType} onChange={props.updateUseCaseType}>
          <>
            <option hidden>No Configuration</option>
            <option value="custom template" hidden>Custom Template</option>
            { configurationParams && configurationParams.map((params) => (
              <option key={params._id} value={params.name}>
                {params.name}
              </option>
            ))}
          </>
        </select>
      </div>

      {hasTempoConfigParams && (
        <div>
          <h6 className={classes.noUpdateMessage}>
            The following values will not be updated when changing Use Case Type
          </h6>
          <h5>Tempo Configuration:</h5>
          <div className={classes.tempoConfigFlexbox}>
            <div className={classes.tempoConfigBox}>
              <h6>iOS</h6>
              <div>
                <p>{`Tempo Update Interval: ${lodashGet(
                  project,
                  "configurationParameters.iosConfig.tempo.tempoUpdateInterval",
                  "Not Set"
                )}`}</p>
              </div>
              <div>
                <p>{`Tempo Timeout Period: ${lodashGet(
                  project,
                  "configurationParameters.iosConfig.tempo.tempoTimeoutPeriod",
                  "Not Set"
                )}`}</p>
              </div>
            </div>
            <div className={classes.tempoConfigBox}>
              <h6>Android</h6>
              <div>
                <p>{`Tempo Update Interval: ${lodashGet(
                  project,
                  "configurationParameters.androidConfig.tempo.tempoUpdateInterval",
                  "Not Set"
                )}`}</p>
              </div>
              <div>
                <p>{`Tempo Timeout Period: ${lodashGet(
                  project,
                  "configurationParameters.androidConfig.tempo.tempoTimeoutPeriod",
                  "Not Set"
                )}`}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="submit-button">
        <button className="btn btn-primary" onClick={props.openModal}>
          Save changes
        </button>
      </div>

      {/* Confirmation Modal */}
      <Modal show={props.showModal} onHide={props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            Are you sure you would like to set this configuration
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="edit-project-confirmation-modal">
            <div className="flex">
              <p>
                <b>Project: </b>
              </p>
              <p>{project && project.name}</p>
            </div>

            <div className="flex">
              <p>
                <b>Template: </b>
              </p>
              <p>{useCaseType}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize="large" onClick={props.closeModal}>
            Cancel
          </Button>
          <Button
            bsStyle="success"
            bsSize="large"
            onClick={props.updateConfigParams}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  ); // return
}; // ProjectConfig

export default ProjectConfig;
